module.exports = __webpack_public_path__ + "static/1-6c42dc11d23b458e7e84ced98142bb9e.jpg";